<template>
  <v-app>
    <div class="card">
      <div class="card-body">
        <!--begin: Wizard Form-->
        <div class="row">
          <div class="col-md-8 col-sm-12 col-lg-8 col-xs-12">
            <div class="col-md-6 col-lg-6 col-sm-12">

              <h4>
                Return book
              </h4>
              <router-link :to="{ name: 'dashboard' }">
                Dashboard
              </router-link>
              \
              Return book
            </div>

          </div>

          <div class="col-md-4 col-sm-12 col-lg-4 col-xs-12 text-right">
          </div>
        </div>
        <return-book></return-book>

      </div>
    </div>
  </v-app>
</template>

<script>
import IssueService from "@/core/services/library/issue/IssueService";
import UserInfoService from "@/core/services/user/UserInfoService";
import BookMixin from "@/mixins/BookMixin";
import ReturnBook from "@/view/component/ReturnBook";

const issueService = new IssueService();
const userService = new UserInfoService();


export default {
  name: "IssueBook",
  mixins: [BookMixin],
  components: {
    ReturnBook
  },
  data() {
    return {
      issue: {},
      selected_book: {},
      selected_user: {},
      selected_list: [],
      search: null,
      search_by_accession: true,
      key: null,
      search_user: null,
      loading: false,
      users: [],
      issue_date: null,
    }
  }, watch: {
    search(val) {
      if (val)
        this.searchBook(val)
    },
    search_user(newValue, oldValue) {
      if (newValue)
        this.searchUser({name: newValue})
    },
    current_user() {
      return this.$store.getters.currentUser;
    },
    search_by_accession(val) {
      this.$refs.search_field.focus();
    }
  },
  mounted() {
    this.issue_date = this.$moment(new Date()).format('DD/MM/YYYY')
    this.getLibrarySetting()
  },
  methods: {
    __search() {
      if (this.search_by_accession) {
        this.searchBookByAccession(this.key);
      } else {
        this.searchByUser();
      }
    },
    async searchUserBy() {
      let data = {}
      if (!this.barcode_enabled) {
        data = {name: this.key}
      } else {
        data = {barcode: this.key}
      }
      if (this.key && this.key.length > 3)
        await this.searchUser(data)
      else {
        this.users = [];
        this.selected_user = {}
        this.user = {}
      }

    },
    pushValueInSelectedBook() {
      let isAlreadyExist = false
      if (this.selected_book.book_id) {
        if (this.selected_list.length == 0) {
          this.selected_list.push(this.selected_book)
        } else if (parseInt(this.selected_list.length) < parseInt(this.library_setting.max_book_allowed)) {
          this.selected_list.forEach(ele => {
            if (ele.book_id == this.selected_book.book_id) {
              isAlreadyExist = true
            }
          })
          if (!isAlreadyExist) {
            this.selected_list.push(this.selected_book)
          } else {
            this.$snotify.error("Book is already in a list")
          }
        } else {
          this.$snotify.error("Maximum no of book allowed reached")
        }


      }
      this.selected_book = {}
    },
    getUser() {
      this.getUserById(this.selected_user.id)
      this.issuedBook(this.selected_user.id, 'currently')
    },
    removeFromList(index) {
      this.$confirm({
        message: `Are you sure you want to remove book from list?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.loading = true
            setTimeout(() => {
              this.selected_list.splice(index, 1)
              this.loading = false
            }, 1000)
          }
        }
      })

    },
    issueBookForUser() {
      this.$confirm({
        message: `Are you sure you want to issue those books to selected user ?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.loading = true;
            issueService.issueBookForUser(this.user.id, this.selected_list).then(response => {
              this.loading = false;
              this.$snotify.success("Book has been issued successfully")
              this.selected_list = [];
              this.user = {}
              this.$emit('refresh-list')
            }).catch(error => {
              this.loading = false;
              this.$snotify.error("Something went wrong")
            })
          }
        }
      });
    },
    getItemText(item) {
      console.log(item)
    }, onUserSelected(item) {
      this.selected_user = item;
      this.getUser();
    }, onBookSelected() {
      this.pushValueInSelectedBook();
    }
  }
}
</script>

<style scoped>

</style>